import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useContainer } from "@contexts/container-context";

export const invalidateClassroomsQueries = (queryClient, classroomIds) => {
  // Invalidate classrooms query to refresh the table data
  queryClient.invalidateQueries({ queryKey: ["classrooms"] });
  // Invalidate classroom details for the passed classroom ids
  queryClient.invalidateQueries({
    predicate: (query) =>
      query.queryKey.includes("classroomDetails") &&
      classroomIds?.includes(query.queryKey[1]),
  });
};

export const useArchiveClassrooms = ({ invalidateOnSuccess }) => {
  const { classroomService } = useContainer();
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ["archiveClassrooms"],
    mutationFn: ({ classroomIds, organizationCode, options }) =>
      classroomService.archiveClassrooms(
        classroomIds,
        organizationCode,
        options
      ),
    onSuccess: (data) => {
      if (data.archived?.length > 0 && invalidateOnSuccess) {
        invalidateClassroomsQueries(queryClient, data.archived);
      }
    },
  });
};

export const useUnarchiveClassrooms = ({ invalidateOnSuccess } = {}) => {
  const { classroomService } = useContainer();
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ["unarchiveClassrooms"],
    mutationFn: ({ classroomIds, organizationCode }) =>
      classroomService.unarchiveClassrooms(classroomIds, organizationCode),
    onSuccess: (_data, { classroomIds }) => {
      if (invalidateOnSuccess) {
        invalidateClassroomsQueries(queryClient, classroomIds);
      }
    },
  });
};
